import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useUserTeam from '../../../../hooks/useUserAccessTeam';
import ROUTES from '../../../../constants/ROUTES';

import scrollbarStyle from '../../../../scrollbar.module.css';
import ComposeEmailIcon from '../../../../assets/ComposeEmail.svg';
import InboxIcon from '../../../../assets/Inbox.svg';
import AeroplaneIcon from '../../../../assets/AeroplaneIcon.svg';
import BoxIcon from '../../../../assets/BoxIcon.svg';
import DownArrow from '../../../../assets/DownArrow.svg';

const CommunicationsTab = ({ closeModal }) => {
  const navigate = useNavigate();
  const userTeam = useUserTeam(false);
  const { pathname } = useLocation();
  const [selectedTeamId, setSelectedTeamId] = useState(null);

  useEffect(() => {
    // Check if the pathname matches a team route
    if (pathname.startsWith(ROUTES.mailer)) {
      const pathParts = pathname.split('/');
      const teamId = pathParts[pathParts.length - 1];

      // If team ID is not 'me' and is a valid number
      if (teamId !== 'me' && !isNaN(parseInt(teamId))) {
        setSelectedTeamId(parseInt(teamId));
      }
    }
  }, [pathname]);

  return (
    <div
      className={`flex flex-col h-[95vh] overflow-y-auto ${scrollbarStyle?.customScrollLight}`}
    >
      <button
        onClick={() => {
          closeModal();
          navigate(ROUTES.composeEmail);
        }}
        className={`flex flex-row items-center gap-x-2 p-1 rounded-md ${
          pathname === ROUTES.composeEmail
            ? 'bg-neutral-200/20'
            : 'hover:bg-neutral-200/20'
        }`}
      >
        <img
          src={ComposeEmailIcon}
          alt='Compose Email Icon'
          className='h-6 w-5'
        />
        <span className='text-white text-sm'>Compose</span>
      </button>

      <div className='flex flex-col gap-y-1 mt-2.5'>
        <button
          onClick={() => {
            closeModal();
            navigate(`${ROUTES.mailer}/inbox/me`);
          }}
          className={`flex flex-row items-center gap-x-2 p-1 py-1.5 rounded-md ${
            pathname === `${ROUTES.mailer}/inbox/me`
              ? 'bg-neutral-200/20'
              : 'hover:bg-neutral-200/20'
          }`}
        >
          <img src={InboxIcon} alt='Inbox Icon' className='h-6 w-5' />
          <span className='text-white text-sm'>Your inbox</span>
        </button>

        {/* <button
          onClick={() => {
            closeModal();
            navigate(`${ROUTES.mailer}/sent/me`);
          }}
          className={`flex flex-row items-center gap-x-2 p-1 py-1.5 rounded-md ${
            pathname === `${ROUTES.mailer}/sent/me`
              ? 'bg-neutral-200/20'
              : 'hover:bg-neutral-200/20'
          }`}
        >
          <img src={AeroplaneIcon} alt='Inbox Icon' className='h-5 w-5' />
          <span className='text-white text-sm'>Sent</span>
        </button> */}

        <button
          onClick={() => {
            closeModal();
            navigate(`${ROUTES.mailer}/archive/me`);
          }}
          className={`flex flex-row items-center gap-x-2 p-1 py-1.5 rounded-md ${
            pathname === `${ROUTES.mailer}/archive/me`
              ? 'bg-neutral-200/20'
              : 'hover:bg-neutral-200/20'
          }`}
        >
          <img src={BoxIcon} alt='Inbox Icon' className='h-6 w-5' />
          <span className='text-white text-sm'>Archive</span>
        </button>
      </div>

      <div className='flex flex-col gap-y-1 mt-2.5 px-1'>
        <span className='text-bold text-white'>Teams</span>

        <div className='flex flex-col gap-y-4 mt-1'>
          {userTeam?.teams?.map((teamDetails, index) => (
            <TeamCollapseAbleMenu
              key={index}
              teamDetails={teamDetails}
              isOpen={selectedTeamId === teamDetails?.value}
              onTeamClick={(teamID) => {
                setSelectedTeamId(teamID);
              }}
              closeModal={closeModal}
              pathname={pathname}
            />
          ))}

          {/* Handle For No teams */}
          {userTeam?.teams?.length === 0 && (
            <div className='flex flex-col gap-y-1'>
              <span className='text-white/50 text-sm'>No teams available</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const TeamCollapseAbleMenu = ({
  teamDetails,
  isOpen,
  onTeamClick,
  pathname,
  closeModal
}) => {
  const navigate = useNavigate();

  return (
    <div className='flex flex-col gap-y-1'>
      <button
        onClick={() => onTeamClick(isOpen ? null : teamDetails?.value)}
        className='flex flex-row items-center gap-x-2.5'
      >
        <img
          src={DownArrow}
          className={`${isOpen ? '' : '-rotate-90'}`}
          alt='Down arrow'
        />
        <span className='text-white text-sm'>{teamDetails?.label}</span>
      </button>

      {isOpen && (
        <div className='flex flex-col gap-y-1.5 ml-5'>
          <button
            onClick={() => {
              closeModal();
              navigate(`${ROUTES.mailer}/inbox/${teamDetails?.value}`);
            }}
            className={`flex flex-row items-center gap-x-2 p-1 py-1 rounded-md ${
              pathname === `${ROUTES.mailer}/inbox/${teamDetails?.value}`
                ? 'bg-neutral-200/20'
                : 'hover:bg-neutral-200/20'
            }`}
          >
            <img src={InboxIcon} alt='Inbox Icon' className='h-6 w-5' />
            <span className='text-white text-sm'>Inbox</span>
          </button>

          <button
            onClick={() => {
              closeModal();
              navigate(`${ROUTES.mailer}/sent/${teamDetails?.value}`);
            }}
            className={`flex flex-row items-center gap-x-2 p-1 py-1 rounded-md ${
              pathname === `${ROUTES.mailer}/sent/${teamDetails?.value}`
                ? 'bg-neutral-200/20'
                : 'hover:bg-neutral-200/20'
            }`}
          >
            <img src={AeroplaneIcon} alt='Inbox Icon' className='h-5 w-5' />
            <span className='text-white text-sm'>Sent</span>
          </button>

          <button
            onClick={() => {
              closeModal();
              navigate(`${ROUTES.mailer}/archive/${teamDetails?.value}`);
            }}
            className={`flex flex-row items-center gap-x-2 p-1 py-1 rounded-md ${
              pathname === `${ROUTES.mailer}/archive/${teamDetails?.value}`
                ? 'bg-neutral-200/20'
                : 'hover:bg-neutral-200/20'
            }`}
          >
            <img src={BoxIcon} alt='Inbox Icon' className='h-6 w-5' />
            <span className='text-white text-sm'>Archive</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default CommunicationsTab;
